
import { Box } from "@orion/ui";
import React from "react";

export const Divider: React.FC<{}> = () => {
  return <Box py6 mr6 ml3 style={{width:"1px", backgroundColor:"black"}} />;
};

Divider.displayName = "Divider";